import { useEffect, useState } from 'react';
import { Camera, ImagePlus, X } from 'lucide-react';
import Button from '../common/Button';

function ImageUpload({ id, label, value, onChange, required = false, hint }) {
  const [preview, setPreview] = useState('');

  useEffect(() => {
    if (!value) { setPreview(''); return undefined; }
    if (typeof value === 'string') { setPreview(value); return undefined; }
    const url = URL.createObjectURL(value);
    setPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [value]);

  const select = (event) => {
    const file = event.target.files?.[0];
    if (file) onChange(file);
    event.target.value = '';
  };

  return <div className="rounded-control border p-3">
    <div className="flex items-start justify-between gap-3">
      <div><p className="text-sm font-medium text-content-primary">{label}{required && <span className="text-danger-600"> *</span>}</p>{hint && <p className="mt-0.5 text-xs text-content-muted">{hint}</p>}</div>
      {value && <Button type="button" variant="ghost" size="sm" onClick={() => onChange(null)}><X className="size-4" /> Quitar</Button>}
    </div>
    {preview && <img src={preview} alt={`Vista previa de ${label}`} className="mt-3 h-36 w-full rounded-control border bg-slate-50 object-contain" />}
    <div className="mt-3 grid gap-2 sm:grid-cols-2">
      <label className="flex cursor-pointer items-center justify-center gap-2 rounded-control border bg-white px-3 py-2 text-sm font-medium text-content-secondary hover:bg-slate-50">
        <Camera className="size-4" /> Tomar foto
        <input id={`${id}-camera`} type="file" accept="image/*" capture="environment" onChange={select} className="sr-only" />
      </label>
      <label className="flex cursor-pointer items-center justify-center gap-2 rounded-control border bg-white px-3 py-2 text-sm font-medium text-content-secondary hover:bg-slate-50">
        <ImagePlus className="size-4" /> Galería o archivos
        <input id={`${id}-files`} type="file" accept="image/*" onChange={select} className="sr-only" />
      </label>
    </div>
  </div>;
}

export default ImageUpload;
